<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-0': $vuetify.breakpoint.xs,'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout row wrap align-center
                          justify-space-between :class="{'mx-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex sm8 xs12>
                        <h1 class="section-title-main my-3 font-weight-regular">{{ $t("Вопрос-ответ") }}</h1>
                    </v-flex>
                    <!-- <v-flex sm4 text-sm-right text-xs-left>
                        <buttonRed slot="activator" @click.native="OPEN_MODAL()">{{$t($t("Задать вопрос"))}}</buttonRed>
                    </v-flex> -->
                </v-layout>
                <v-layout row wrap align-end
                          justify-space-between mb-5 :class="{'mx-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex sm5 xs12 :class="{'mb-4': $vuetify.breakpoint.xs,'mr-4 mb-0': $vuetify.breakpoint.smAndUp}">
                        <inputIcon v-model="questions_search" class="layout row search--no-border" icon_name="search"
                                   :placeholder="$t('Поиск по разделу')"
                        />
                    </v-flex>
                    <!-- <v-flex sm6>
                        <div class="grey-text mb-2">{{$t("Тема вопроса")}}</div>
                        <v-select
                            v-model="theme"
                            :items="themes"
                            solo
                            append-icon="expand_more"
                            :placeholder="theme ? undefined : $t('Сделайте выбор')"
                            class="input"
                            @change="CLEAR_PAGES"
                        />
                    </v-flex> -->
                </v-layout>

                <div v-if="filtered.length==0" class="subheading">{{ $t("Нет вопросов") }}</div>
                <v-layout v-else :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-expansion-panel
                        v-model="value"
                        :value="value"
                        expand
                    >
                        <v-expansion-panel-content
                            v-for="(item_list,index) in paginated"
                            :key="index"
                            expand-icon=""
                        >
                            <v-layout slot="header" align-center
                                      justify-space-between
                            >
                                <v-flex xs12 sm8 md9
                                        :class="{'mb-3': $vuetify.breakpoint.smAndDown}"
                                >
                                    <v-layout column>
                                        <div class="grey-text body-2">
                                            {{ item_list.theme }}
                                        </div>
                                        <v-flex>{{ item_list.title }}</v-flex>
                                    </v-layout>
                                </v-flex>
                                <roundButton :icon_name="value[index] ? 'minus' : 'plus'" :class="{'btn--icon-white': value[index], 'ml-3': $vuetify.breakpoint.smAndDown, 'ml-4': $vuetify.breakpoint.mdAndUp}" />
                            </v-layout>
                            <v-card class="mb-4">
                                <div v-html="item_list.text"></div>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-layout>
                <v-layout my-5 justify-space-between
                          align-center
                          wrap :class="{'mx-3': $vuetify.breakpoint.xs}"
                >
                    <!-- <v-flex md3 sm3 xs6
                            mb-4
                    >
                        <buttonRed slot="activator" class="mr-5" @click.native="OPEN_MODAL()">{{$t("Задать вопрос")}}</buttonRed>

                    </v-flex> -->
                    <v-flex v-if="filtered.length > 10" md5 sm7
                            xs12
                            mb-4
                    >
                        <div class="text-xs-center">
                            <v-pagination
                                v-model="page"
                                :length="Math.ceil(filtered.length / selected_number)"
                                :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                                prev-icon="arrow_back_ios"
                                next-icon="arrow_forward_ios"
                                @input="reset(value)"
                            />
                        </div>
                    </v-flex>
                    <v-flex v-if="filtered.length > 10" md4 sm6
                            mb-4
                    >
                        <v-select
                            :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                            : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                            solo
                            append-icon=""
                            :label="$t('Показывать по 10')"
                            class="input"
                            @change="show_number($event, 10)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-layout>
            <!-- <v-dialog :value="question_modal" max-width="620" persistent
                      no-click-animation
            >
                <FAQModal />
            </v-dialog> -->
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import labelTopic   from '@/components/ui/labels/label_topic';
import buttonRed   from '@/components/ui/buttons/button_red';
import roundButton   from '@/components/ui/buttons/buttons_icon/round_button';
import FAQModal   from './FAQ_modal';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    buttonRed,
    roundButton,
    labelTopic,
    FAQModal,
  },
  data() {
    return {
      value : [],
      search: '',
    };
  },
  computed: {
    ...mapGetters('faq/breadcrumbs', [
      'breadcrumbs',
    ]),
    ...mapGetters('faq/questions', [
      'list',
      'question_modal',
      'themes',
      'selected_page',
      'selected_theme',
      'selected_number',
      'filtered_by_theme',
      'search_by_string',
      'paginated',
      'search_string',
    ]),
    theme: {
      get() {
        return this.selected_theme;
      },
      set($event) {
        return this.SET_SELECTED_THEME($event);
      },
    },
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    questions_search: {
      get() {
        return this.search;
      },
      set($event) {
        return this.SEARCH_STRING($event.target.value);
      },
    },
    filtered() {
      return this.search_string ? this.search_by_string : this.filtered_by_theme;
    },
  },
  mounted() {
    this.get_faq_questions();
  },
  methods: {
    reset() {
      this.value=[];
    },
    ...mapMutations('faq/questions', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_SELECTED_THEME',
      'SET_SELECTED_PAGE',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SEARCH_STRING',
    ]),
    ...mapActions('faq/questions', [
      'show_number',
      'get_faq_questions',
    ]),
  },
};
</script>
